import { ActionButtonProps } from "@able/react/dist/ActionButton";
import { ErrorComponent } from "../util/helpers";
import { useSheetModalContext } from "./context";
import SheetModal, { SheetModalProps } from "./SheetModal";
import { PropsWithChildren } from "react";

export type SheetProps = Omit<SheetModalProps, 'footerSetting' | 'onClose' | 'id'> & {
    level: number;
    onApply?: (e?: any) => void;
    id: string;
    htmlId?: string;
    footer?: boolean;
};

const Sheet = (props: SheetProps) => {
    const { children, level, id, htmlId, footer = true, onApply, ...rest } = props;
    const multiSheetContext = useSheetModalContext(); // MultiSheet context value

    if (!multiSheetContext) {
        return <ErrorComponent>{`SheetContext not defined, wrap it inside <MultiSheet>`}</ErrorComponent>;
    }

    const { open, developmentUrl, nextLevel, previousLevel, currentLevel, maxLevel = 0, onApplySheet, sheetId, closeModal } = multiSheetContext; // MultiSheet props 

    const onBackEvent = {
        onClick: previousLevel
    }
    const onNextEvent = {
        onClick: nextLevel
    }
    const onApplyEvent = {
        onClick: () => {
            onApplySheet && onApplySheet(sheetId);
            onApply && onApply(sheetId);
        }
    }

    if (level === currentLevel && id === sheetId) {

        const backButton = {
            label: 'Back',
            element: 'button',
            variant: "MediumEmphasisCompact",
            events: onBackEvent
        } as ActionButtonProps;

        let footerSetting: SheetModalProps['footerSetting'] = {};

        if (currentLevel > 1 && currentLevel === maxLevel) {
            footerSetting = {
                buttonOne: backButton,
                buttonTwo: {
                    label: 'Apply',
                    element: 'button',
                    variant: "HighEmphasisCompact",
                    events: onApplyEvent
                }
            }
        }
        else if (currentLevel > 1 && currentLevel < maxLevel) {
            footerSetting = {
                ...footerSetting,
                buttonOne: backButton,
                buttonTwo: {
                    label: 'Next',
                    element: 'button',
                    variant: "HighEmphasisCompact",
                    events: onNextEvent
                }
            }
        }

        if (footer === false) {
            footerSetting = undefined;
        }

        return <SheetModal
            {...multiSheetContext}
            {...rest}
            id={htmlId}
            open={open}
            onClose={closeModal} // Close the multi sheet modal
            developmentUrl={developmentUrl}
            footerSetting={footerSetting} >{children}</SheetModal>
    }

    return null;
}

export const DefaultSheet = ({ title, children }: Pick<SheetProps, 'title'> & PropsWithChildren) => {
    return <Sheet id="default" level={1} title={title} footer={false}>
        {children}
    </Sheet>
}

export default Sheet;